import React from 'react'

import { AuthContextProvider } from './Auth'

type Props = {
    children: React.ReactNode
}

export const ContextProviders: React.FC<Props> = ({ children }) => {
    return <AuthContextProvider>{children}</AuthContextProvider>
}
